<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="popupContainer"
    :center="true"
  >
    <span>这是一段信息</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "guide",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClose(done) {
      this.closePopup();
    },
    closePopup() {
      this.$emit("closeModal");
    }
  },
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
</style>